import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { PaymentUtilService } from '../../../common/payment/services';
import { IBasicInfo, IFundraiser } from '../../../fundraiser/models/fundraiser.model';
import { IUser } from '../../../shared/models';
import { AuthService, EventsService, FbService, FundraiserService, StorageService, UtilService, VariablesService, VwoService } from '../../../shared/services';
@Component({
  selector: 'app-update-page',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  config = {
    sipPitch: false,
    allowOneTimeDonation: false
  };
  fundraiser: IFundraiser;
  basicInfo = {} as IBasicInfo;
  latestUpdate: any = {
    data: []
  };
  isLatestUpdate;
  param: any = {};
  campaign_url;
  entity_id;
  showShareBanner = false;
  currencyIcon;
  viewMoreUpdatesCount = 1;
  isCommentPosted;
  isCommentVisible;
  isFooterVisible;
  currencyInfo;
  userData: IUser;
  isFundraiserEnded;
  sharedCounts = {
    fb: 0,
    whatsapp: 0
  };
  utm_params = {
    utm_source: 'internal',
    utm_content: '',
    utm_campaign: ''
  };
  updateType = {
    urgent: {
      label: `Need Urgent Attention!`,
      color: '#d37171',
      icon: 'icon-emergency',
      reaction: 'icon-support',
      filled: 'icon-supportfilled'
    },
    great: {
      label: `I've got great news!`,
      color: '#ffbc00',
      icon: 'icon-thumbsup',
      reaction: 'icon-heart',
      filled: 'icon-heartfilled'
    },
    quick: {
      label: `Here's a quick update`,
      color: '#576da8',
      icon: 'icon-instant',
      reaction: 'icon-thumbsup',
      filled: 'icon-thumbsupfilled'
    },
    sad: {
      label: `I'm sad to inform you...`,
      color: '#a2724f',
      icon: 'icon-sad',
      reaction: 'icon-sad',
      filled: 'icon-sadfilled'
    },
    success: {
      label: `YOU made it happen!`,
      color: '#0fd3cd',
      icon: 'icon-balloons',
      reaction: 'icon-claps',
      filled: 'icon-clapsfilled'
    }
  };
  updatesSummary;
  updateReact = 0;
  updates: any = {
    data: []
  };
  similarFundraisers;
  ExitlistenerFn: () => void;
  @ViewChild('similarFundraiser', { static: true }) public similarFundraiserRef: TemplateRef<HTMLElement>;
  isMobile: any;
  pageData;

  // pwa variables declaration
  deferredPrompt: any;
  showButton = false;
  docker = {
    visible: false,
    label: 'Contribute Now',
    isDonated: false
  };

  showOffer = false;

  constructor(
    public actRoute: ActivatedRoute,
    public fundraiserService: FundraiserService,
    public storageService: StorageService,
    public utilService: UtilService,
    public fbService: FbService,
    public variablesService: VariablesService,
    public eventsService: EventsService,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private authService: AuthService,
    private swUpdate: SwUpdate,
    private cdr: ChangeDetectorRef,
    private paymentUtilService: PaymentUtilService,
    public vwo: VwoService,

    public events: EventsService,

  ) {
    this.utilService.router.navigate([], { queryParams: { pr: null }, queryParamsHandling: 'merge' });
  }

  ngOnInit() {
    this.utm_params['utm_content'] = `${this.utilService.getUserData()?.id}`;
    this.isMobile = this.utilService.isMobile();
    this.variablesService.campaignType = 'update';
    if (typeof document !== 'undefined') {
      this.utilService.doc.body.classList.add('updatePage');
    }
    this.variablesService.pageName = 'update';
    this.prefill();
    this.getParam();
    // pwa init //
    this.reloadCache();
    if (this.param.st === 'f' && this.param.type === 'onetime') {
      this.paymentUtilService.isSubmitted.next(true);
    }
    this.getCurrency();
    this.fbService.loadFBScript();
    this.commentTimeout();
    this.checkForLogin();
    this.variablesService.mainLayoutConfig.next({
      showHeader: true,
      showFooter: true,
      showMenus: true,
      showProfile: true,
      showSearch: true,
      logoNavigate: true,
      headerTopSticky: false
    });
    this.setPageData();
  }

  async prefill() {
    try {
      await this.authService.userLoginWithEmail(this.actRoute.snapshot.queryParams);
    } catch (error) { }
  }

  getFundraiserDetailsById(id) {
    const curr = this.currencyInfo || this.param?.currency?.toUpperCase() || this.param?.donated_currency?.toUpperCase() || 'INR';
    const qParam = `?with=beneficiaryname;theater;leaderboard;raised;thankyouvideo;basicinfo;campaigner&currency=${curr}`;
    this.fundraiserService.getCampaignViaID(id, qParam).subscribe((res: any) => {
      this.variablesService.fundraiser = res.data;
      this.updatesSummary = res;
      this.setBasicInfo(res.data.basicinfo);
      this.isFundraiserEnded = this.utilService.checkFundraiserEnded(res.data.status_flag, res.data.end_date);
      if (this.param['sip'] && (this.param['sip'] === 'true')) {
        return;
      }
      this.getSimilarFundraisers(this.variablesService.fundraiser.id);
    });
  }

  reloadCache() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if (confirm('New version available! Would you like to update?')) {
          window.location.reload();
        }
      });
    }
  }

  // PWA on download
  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    e.userChoice.then(choiceResult => {
      if (choiceResult.outcome === 'dismissed') {
        // They dismissed, send to analytics
      } else {
      }
    });

    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.showButton = true;
  }

  addToHomeScreen() {
    // hide our user interface that shows our A2HS button
    this.showButton = false;
    // Show the prompt
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          const payload = {
            eventName: 'add_to_homescreen',
            event_type: 'impact',
            info_1: 'position',
            info_2: 1,
          };
          this.eventsService.sendSystemEvent(payload).subscribe();
        } else {
        }
        this.deferredPrompt = null;
      });
  }


  /**Get the params from URL */
  getParam() {
    this.param = this.actRoute.snapshot.queryParams;
    this.getFundraiserDetailsById(this.param['fmd_id']);
    this.getFundraiserUpdates(this.param['fmd_id'], this.param['update_id'], 'INR');
    this.getLatestUpdate(this.param['fmd_id']);
    this.pageViewEvents(this.param['fmd_id']);
  }

  /**Recieve react event from comment banner and transmit it to update component */
  reactOnUpdate(event) {
    this.updateReact = this.updateReact + 1;
  }

  /**Check for login */
  checkForLogin() {
    this.variablesService.userData.subscribe({
      next: (resp) => {
        this.userData = resp;
        this.sipCheck();
        if (this.userData && this.userData.aggdonationall && this.userData.aggdonationall.funds) {
          this.docker.isDonated = true;
          this.docker.label = 'See My Impact Now';
          this.cdr.detectChanges();
        } else {
          this.docker.isDonated = false;
          this.docker.label = 'Contribute Now';
        }
      }
    });
  }

  /**
   * Sends system event
   */
  sendSystemEvent(): void {
    this.eventsService.sendSystemEvent({
      eventName: 'incentive_popup',
      info_3: 'impact',
      page_name: this.variablesService.pageName
    }).subscribe(_ => _);
  }

  /**Show comment banner 7 seconds after page load */
  commentTimeout() {
    setTimeout(() => {
      this.isCommentVisible = true;
      setTimeout(() => {
        if (this.utilService.doc.querySelector('.comment-banner-area .cm-input')) {
          this.utilService.doc.querySelector('.comment-banner-area .cm-input').setAttribute('autofocus', '');
        }
      }, 500);
    }, 7000);
  }

  /**View More Updates */
  viewMoreUpdates(event) {
    if (event) {
      this.loadPreviousUpdates(this.updates.next_page_url);
    }
  }

  /**Toggle comment and share banner after successfull comment */
  commentPosted(event) {
    this.isCommentPosted = event;
  }

  footerVisible(event) {
    this.isFooterVisible = event.visible;
  }

  /**Hide comment banner when update comment is visible */
  CommentVisible(event) {
    if (this.isMobile && !this.isFooterVisible) {
      this.isCommentVisible = !event;
    }
  }

  /**View Latest Update */
  viewLatestUpdate() {
    this.getFundraiserUpdates(this.param.fmd_id, this.latestUpdate.data[0].id, 'INR');
  }

  /**Load Previous Updates */
  loadPreviousUpdates(url) {
    this.fundraiserService.getPreviousUpdates(url).subscribe((res: any) => {
      this.updates = res.data;
      for (let i = 0; i < this.updates.data.length; i++) {
        if (!this.updates.data[i].user_liked) {
          this.updates.data[i].user_liked = { 'status': 0 };
        }
        if (this.updates.data[i].owner) {
          this.updates.data[i].owner.creation_date = this.updates.data[i].creation_time;
        } else {
          this.updates.data[i].owner = { creation_date: this.updates.data[i].creation_time };
        }
        const qParam1 = `/${this.updates.data[i].id}/comments`;
        this.fundraiserService.getFundraiserUpdates(this.updates.data[0].updatable.custom_tag, qParam1).subscribe((res1: any) => {
          this.updates.data[i]['comments'] = res1.data;
          this.updates.data[i]['comments'].placeholder = '';
        });
      }
      this.utm_params.utm_campaign = this.updates.data[0].updatable.custom_tag;
      this.getFacebookShares(this.utm_params.utm_campaign);
      // this.getWhatsappShares();
    });
    this.utilService.scrollIntoViewSmoothly('update-section');
  }

  /**Get fundraiser updates */
  getFundraiserUpdates(customTag, updateId, currency) {
    // tslint:disable-next-line:max-line-length
    const qParam = `?with=userLiked;updatable.campaigner;owner.avtar&id=${updateId || customTag}&currency=${currency}&limit=1&orderBy=id&sortedBy=desc`;
    this.fundraiserService.getFundraiserUpdates(customTag, qParam).subscribe((res: any) => {

      this.updates = res.data;

      if (this.updates.data.length) {
        // tslint:disable-next-line: max-line-length
        this.isFundraiserEnded = this.utilService.checkFundraiserEnded(this.updates?.data[0]?.updatable?.status_flag, this.updates?.data[0]?.updatable?.end_date);
        this.sipCheck();

        this.utm_params.utm_campaign = this.updates.data[0].updatable.custom_tag;
        this.campaign_url = this.utilService.domain_details.domain_url + `/fundraiser/` + this.utm_params.utm_campaign;
        // if (this.currencyInfo) {
        //   this.getFundraiserSummary(this.utm_params.utm_campaign, this.currencyInfo);
        // }
        this.updates.data['facebook'] = { 'label': 'Spread the word' };
        this.updates.data['whatsapp'] = { 'label': 'Share on Whatsapp' };
        if (this.utilService.isBrowser) {
          this.getFacebookShares(this.utm_params.utm_campaign);
          // this.getWhatsappShares();
          for (let i = 0; i < this.updates.data.length; i++) {
            if (!this.updates.data[i].user_liked) {
              this.updates.data[i].user_liked = { 'status': 0 };
            }
            this.updates.data[i].owner.creation_date = this.updates.data[i].creation_time;
            const qParam1 = `/${this.updates.data[i].id}/comments`;
            this.fundraiserService.getFundraiserUpdates(this.updates.data[0].updatable.custom_tag, qParam1).subscribe((res1: any) => {
              this.updates.data[i]['comments'] = res1.data;
              this.updates.data[i]['comments'].placeholder = '';
            });
          }
        }
      }

    });
  }

  /**Call fundraiser API to get raised, supporters, whatsapp/facebook content */
  // getFundraiserSummary(customTag, currency) {
  //   const qParam = `?with=beneficiaryname;theater;leaderboard;raised;thankyouvideo;basicinfo;campaigner&currency=${currency}`;
  //   this.fundraiserService.getFundraiserSummary(customTag, qParam).subscribe((res: any) => {
  //     this.variablesService.fundraiser = res.data;
  //     this.updatesSummary = res;
  //     this.setBasicInfo(res.data.basicinfo);
  //     this.isFundraiserEnded = this.utilService.checkFundraiserEnded(res.data.status_flag, res.data.end_date);
  //     if (this.param['sip'] && (this.param['sip'] === 'true')) {
  //       return;
  //     }
  //     this.getSimilarFundraisers(this.variablesService.fundraiser.id);
  //   });
  // }
  /**Get the similar fundraiser */
  getSimilarFundraisers(campaignId) {
    const qParam = '?with=leaderboard;widget';
    this.fundraiserService.getSimilarFundraisers(campaignId, qParam).subscribe((res: any) => {
      this.similarFundraisers = res.data;
      if (this.similarFundraisers && this.similarFundraisers.length) {
        this.ExitlistenerFn = this.exitIntent();
      }
    });
  }

  /**Set Basic Info */
  setBasicInfo(data: any[]) {
    if (data && data.length) {
      for (const item of data) {
        this.basicInfo[item.info_type] = item.info_1 || '';
      }
      this.variablesService.basicInfo = this.basicInfo;
    }
  }

  /**Get Latest Update */
  getLatestUpdate(customTag) {
    const qParam = `?orderBy=id&sortedBy=desc&limit=1`;
    this.fundraiserService.getFundraiserUpdates(customTag, qParam).subscribe((res: any) => {
      this.latestUpdate = res.data;
    });
  }

  /**Get Facebook shares */
  getFacebookShares(customTag) {
    const selectedId = this.fbService.getFacebookID();
    const url = `/fundraiser/${customTag}&fields=engagement&access_token=${encodeURI(selectedId)}`;
    this.fundraiserService.getFacebookShares(url).subscribe((res: any) => {
      this.sharedCounts.fb = res.engagement.share_count;
      this.updates.data['facebook'] = {
        'label': 'Spread the word',
        'count': this.sharedCounts.fb,
        'campaign_url': this.utilService.domain_details.domain_url + `/fundraiser/` + this.utm_params.utm_campaign,
        'utm_params': this.updates.data[0].updatable.custom_tag
      };
      this.updates.data['whatsapp'] = { 'label': 'Share on Whatsapp', 'count': this.sharedCounts };
    });
  }

  /**Set the color property */
  getColor(updtype) {
    return updtype ? this.updateType[updtype].color : this.updateType.quick.color;
  }

  /**Get the Update type icon*/
  getUpdateTypeReaction(updtype, reacted) {
    if (reacted) {
      return updtype ? this.updateType[updtype].filled : this.updateType.quick.filled;
    } else {
      return updtype ? this.updateType[updtype].reaction : this.updateType.quick.reaction;
    }
  }

  /**Check if update is latest */
  checkLatestUpdate(linkUpdate, latestUpdate) {
    return linkUpdate === latestUpdate;
  }

  /**
   * Get the currency of the from
   * currency observable
  */
  getCurrency() {
    this.utilService.currency.subscribe((res) => {
      if (res) {
        if (this.actRoute.snapshot.queryParams.currency || this.actRoute.snapshot.queryParams.donated_currency) {
          this.currencyInfo = this.actRoute.snapshot.queryParams.currency || this.actRoute.snapshot.queryParams.donated_currency;
        } else {
          this.currencyInfo = res;
        }
        this.currencyIcon = this.utilService.getCurrencyIcon(this.currencyInfo);
        if (this.utm_params.utm_campaign) {
          // this.getFundraiserSummary(this.utm_params.utm_campaign, this.currencyInfo);
          this.getFundraiserDetailsById(this.utm_params.utm_campaign);
        }
      }
    });
  }

  /**All events */
  pageViewEvents(id) {
    const pageViewSysEvent = {
      eventName: 'pageView',
      event_type: 'campaign',
      event_type_id: id,
      page_name: 'update',
      info_3: this.variablesService.campaignType,
      info_4: ''
    };
    this.eventsService.onLoadSystemEvent(pageViewSysEvent);
  }

  exitIntent() {
    return this.renderer.listen('document', 'mouseout', (event) => {
      if (event.toElement == null && event.relatedTarget == null && event.clientY < 0) {
        if (this.storageService.getFromSession('exitDialogUpdate') !== 'shown') {
          if (typeof document !== 'undefined') {
            const cdk = document.getElementsByClassName('cdk-overlay-container');
            if (!cdk.length) {
              this.openModal();
              this.storageService.addSessionData('exitDialogUpdate', 'shown');
            }
          }
        }
      }
    });
  }
  openModal() {
    this.dialog.open(this.similarFundraiserRef, {
      width: '100vw',
      maxWidth: this.isMobile ? '100%' : '955px',
      height: '100vh',
      maxHeight: this.isMobile ? '100%' : '564px',
      panelClass: ['round-dialog', 'similar-fr-modal']
    });
    this.eventsService.sendSystemEvent(
      {
        eventName: 'similar_fundraiser_popup',
        page_name: this.variablesService.pageName
      }
    ).subscribe(_ => _);
  }

  setPageData() {
    const queryParams = this.actRoute.snapshot.queryParams;
    this.pageData = {
      pageName: 'update',
      redirect_url: `/new/campaign/campaign_update?fmd_id=${queryParams.fmd_id}&update_id=${queryParams.update_id}`
    };
  }

  sipCheck() {
    // tslint:disable-next-line: max-line-length
    if (this.userData && !this.userData?.listsubscriptions?.medical) {
      this.config.sipPitch = true;
      this.showOffer = true;
    }
    if (+this.actRoute.snapshot.queryParams.is_donor !== 1 && !this.isFundraiserEnded) {
      this.config.allowOneTimeDonation = true;
    } else {
      this.config.allowOneTimeDonation = false;
    }
  }

  knowMore() {
    this.utilService.scrollIntoViewSmoothly('donation-form', 180);
    let payload: any = {
      utm_source: 'internal_ketto',
      utm_term: 'upper_banner'
    }
    if (this.param?.utm_source) {
      payload.utm_source = '';
      payload = this.utilService.removeEmptyFromObject(payload);
    }
    this.utilService.router.navigate([], { queryParams: payload, queryParamsHandling: 'merge' }).then(() => {
      this.utilService.setUtm();
    });

    this.eventsService.sendSystemEvent({
      eventName: 'update-top_banner'
    }).subscribe(_ => _);
  }

  ngOnDestroy() {
    if (typeof document !== 'undefined') {
      this.utilService.doc.body.classList.remove('updatePage');
    }
    if (this.ExitlistenerFn) {
      this.ExitlistenerFn();
    }
  }

}
